import Environment from '../../../Environment';
import BaseService, { IHttpResponse, buildUrl } from '../../BaseService';

const RESOURCE = 'headcounts';

interface IEmbeddedHeadcount {
  event?: { id: string };
  session?: { id: string };
  'repeating-event'?: { id: string };
}

interface IUpdateHeadcountRequest {
  id: string;
  token: string;
  org_key?: string;
  app_key?: string;
  count?: number;
  _embedded?: IEmbeddedHeadcount;
}

interface IUpdateHeadcountResponse extends IHttpResponse {
  body?: {
    org_key: string;
    id: string;
    app_key: string;
    count: number;
    _embedded: IEmbeddedHeadcount;
  };
}

export default async ({
  id,
  token,
  org_key,
  app_key,
  count,
  _embedded,
}: IUpdateHeadcountRequest): Promise<IUpdateHeadcountResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    resource: RESOURCE,
    id,
  });

  return BaseService.Patch({
    url,
    token: token,
    data: {
      app_key,
      org_key,
      count,
      _embedded,
    },
  });
};
